export const inputCls =
  "w-full bg-transparent border-b border-[#E5E0D8] rounded-none px-0 py-4 focus:outline-none focus:border-[#7A3B3F] transition-colors duration-300 placeholder:text-[#8A8A8A] text-[#1A1A1A]";

export const FALLBACK_PHOTO =
  "https://images.unsplash.com/photo-1518199266791-5375a83190b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export function resizeImage(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scale = Math.min(1, 600 / Math.max(img.width, img.height));
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}
